// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GWPX","newExpiryDate":"styles_newExpiryDate__oY3tr","footer":"styles_footer__GwMc8"};